import { isProductPage } from '../../utils/gtm-utilities.es6';

(() => {
    const styleCode = window.location.pathname.split('-p-')[1].substring(0, 15);

    function addListener(el, name) {
        el.addEventListener('click', () => {
            window.analyticsSdk.tracking.sendEvent({
                name,
                event: {
                    styleCode
                }
            });
        });
    }

    if (isProductPage()) {
        document.querySelectorAll('.find-in-store-link').forEach(el => {
            addListener(el, 'productPage.clickOnFindInStoreLink');
        });

        document.querySelectorAll('.find-in-store-button').forEach(el => {
            addListener(el, 'productPage.clickOnFindInStoreButton');
        });
    }
})();
